import { render, staticRenderFns } from "./BaseDialog.vue?vue&type=template&id=289ecafb&scoped=true"
import script from "./BaseDialog.vue?vue&type=script&lang=ts"
export * from "./BaseDialog.vue?vue&type=script&lang=ts"
import style0 from "./BaseDialog.vue?vue&type=style&index=0&id=289ecafb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "289ecafb",
  null
  
)

export default component.exports